import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=71dc8118&scoped=true"
import script from "./relations.vue?vue&type=script&lang=js"
export * from "./relations.vue?vue&type=script&lang=js"
import style0 from "./relations.vue?vue&type=style&index=0&id=71dc8118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc8118",
  null
  
)

export default component.exports